<template>
    <header class="institution-header" id="branding-bar-v1" itemscope="itemscope" itemtype="http://schema.org/CollegeOrUniversity">
        <div class="bar">
            <div class="container">
                <div class="unit whole">
                    <h1 class="campus mr-auto">
                        <a title="Indiana University">
                            <img src="@/assets/trident-tab.gif" height="73" width="64" alt=" ">
                            <span class="show-on-desktop" itemprop="name sourceOrganization provider">Indiana University</span>
                            <span class="show-on-tablet" itemprop="name sourceOrganization provider">Indiana University</span>
                            <span class="show-on-mobile" itemprop="name sourceOrganization provider">Indiana University</span>
                        </a>
                    </h1>
                    <b-button-group class="header-buttons">
                        <slot name="log-in-out">
                        <b-button class="btn-success" to="/signin" v-if="auth.uid === ''">
                            <font-awesome-icon icon="sign-in-alt"></font-awesome-icon> <span class=""> Log in</span>
                        </b-button>
                        <b-button class="btn-warning" @click="logout" v-if="auth.uid !== ''">
                            <font-awesome-icon icon="sign-out-alt"></font-awesome-icon> <span class=""> Log out</span>
                        </b-button>
                        </slot>
                        <b-button class="btn-info" v-b-modal.modal1>
                            <font-awesome-icon icon="envelope"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                    <!--<a class="btn btn-warning btn-sm btn-access">-->
                    <!--<span class="glyphicon glyphicon-log-out"></span> <span class=""> Log out</span>-->
                    <!--</a>-->
                </div>
            </div>
        </div>
        <div class="bar subheader">
            <h3 class="site-title">
                <slot name="site-title">
                    SCA Project Title <small>subtitle</small>
                </slot>
            </h3>
            <div class="pull-right text-right" v-if="auth.uid">
                <slot name="greeting">
                    <h6>Welcome <b>{{auth.uid}}</b> <span v-if="auth.role === 'admin'"> (admin)</span></h6>
                </slot>
            </div>
        </div>
        <b-modal id="modal1" title="Contact Us">
            <ContactForm></ContactForm>
        </b-modal>
    </header>
</template>

<script>
    import ContactForm from "@/components/ContactForm";

    export default {
        name: "Header",
        props: {
            auth: Object,
        },
        components: {ContactForm}
    }
</script>

<style scoped>
    .header-buttons {
        position: absolute;
        right: 0px;
    }
</style>
